import type { Task } from "@app/core";

export interface ViewExclusionInputs {
  topicIds: string[];
  calendarIds: string[];
}

/**
 * Route-specific display exclusions for Month/Today. Unlike sidebar filters,
 * these are persisted preferences and only hide tasks from the owning view.
 */
export function applyViewExclusions(tasks: Task[], exclusions: ViewExclusionInputs): Task[] {
  if (exclusions.topicIds.length === 0 && exclusions.calendarIds.length === 0) return tasks;
  const topics = new Set(exclusions.topicIds);
  const calendars = new Set(exclusions.calendarIds);
  return tasks.filter((t) => {
    if (t.calendar_id && calendars.has(t.calendar_id)) return false;
    return !t.topic_ids.some((id) => topics.has(id));
  });
}
